export default __webpack_public_path__ + "static/media/logo-us-kylie.bfadd2fc.svg";